import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {i18n} from '@appbase/util/i18n-setup'
import {initializeAsync as initBoardAsync} from '@board/module'
import {initializeAsync as initAppBaseAsync, initializeTeams} from '@appbase/module'


Vue.config.productionTip = false




//
// ────────────────────────────────────────────────────────────────── I ──────────
//   :::::: I N I T   V U E   R O O T : :  :   :    :     :        :          :
// ────────────────────────────────────────────────────────────────────────────
//

const bootstrap = async () => {
    await initBoardAsync()
    await initAppBaseAsync()
    await initializeTeams().then(() => {
        window.document.body.style.background = "white"
    }).finally(() => {
        new Vue({
            router,
            store,
            i18n,
            render: (h) => h(App),
            beforeCreate() {
            },
        }).$mount('#app')
    })          
}
bootstrap().then();
